module.exports = __webpack_public_path__ + "static/media/pub.9c9f508b.png";